<template>
  <nav class="" @mouseleave="resetMenu()">
    <div class="container flex between-xs py10">
      <div
        v-for="(category, index) in categoriesMap[
          categoryIdsMap.rootCategoryId
        ]"
        :key="category.id"
        @mouseenter="hover(index)"
        class="menu__item pointer middle-xs"
      >
        <div @mouseenter="hoverFirstLevelCategory(category)">
          <router-link
            @click.native="heeadBarShow = false"
            class="menu__item item-hover h6 no-underline cl-gray uppercase"
            :to="
              category.id !== categoryIdsMap.subscriptionCategoryId
                ? categoryLink(category)
                : localizedRoute($t('abonament-modowy-wybierz-pakiet'))
            "
          >
            {{ category.name }}
          </router-link>
        </div>
      </div>
      <div
        @mouseenter="heeadBarShow = false"
        class="menu__item pointer middle-xs"
      >
        <router-link
          :to="localizedRoute('/selling')"
          class="menu__item item-hover h6 no-underline cl-gray uppercase"
        >
          {{ $t("Sell with us") }}
        </router-link>
      </div>
      <div
        @mouseenter="heeadBarShow = false"
        class="menu__item pointer middle-xs"
      >
        <router-link
          :to="localizedRoute('/i/' + $t('about-us'))"
          class="menu__item item-hover h6 no-underline cl-gray uppercase"
        >
          {{ $t("About us") }}
        </router-link>
      </div>
      <div
        @mouseenter="heeadBarShow = false"
        class="menu__item pointer middle-xs"
      >
        <router-link
          :to="localizedRoute('/i/' + $t('contact'))"
          class="menu__item item-hover h6 no-underline cl-gray uppercase"
        >
          {{ $t("Contact") }}
        </router-link>
      </div>
      <transition name="fade">
        <!-- Sekcja dla Projektanci ot A - Z -->
        <div
          v-if="heeadBarShow"
          :class="[
            'megamenu__submenu absolute pb20 pointer',
            { 'special-offer': isSpecialOfferBar },
          ]"
        >
          <!-- Tutaj SubCat z magento -->
          <div class="col-xs-2 mt30 pt5 p0">
            <div class="pt5 uppercase sub-category-header p0">
              {{ $t("Categories") }}
            </div>
            <div
              :class="['submenu-item relative', { active: activeSecondLevelCategory && activeSecondLevelCategory.id === secondLevelCategory.id }]"
              @mouseenter="hoverSecondLevelCategory(secondLevelCategory)"
              v-for="(secondLevelCategory, index) in notIncludedInMenu(
                categoriesMap[secondLevelCategoriesParentId],
              )"
              v-show="index <= 8"
              :key="secondLevelCategory.id"
            >
              <router-link
                @click.native="heeadBarShow = false"
                v-if="secondLevelCategory.include_in_menu !== 0"
                :to="categoryLink(secondLevelCategory)"
                class="py10 flex h5 submenu-text no-underline"
              >
                {{ secondLevelCategory.name }} <span class="arrow-hover">➜</span>
              </router-link>
            </div>
          </div>
          <div class="col-xs-2 mt30 pt5 p0">
            <div class="pt5 uppercase sub-category-header p0">
              {{
                activeSecondLevelCategory ? activeSecondLevelCategory.name : ""
              }}
            </div>
            <div
              class="submenu-item relative"
              v-for="(thirdLevelCategory, index) in thirdLevelCategories"
              v-show="index <= 8"
              :key="thirdLevelCategory.id"
            >
              <router-link
                @click.native="heeadBarShow = false"
                :to="categoryLink(thirdLevelCategory)"
                class="py10 flex h5 submenu-text no-underline"
              >
                {{ thirdLevelCategory.name }}
                <span class="arrow-hover">➜</span>
              </router-link>
            </div>
          </div>
          <!-- Podsekcja dla Zjęć dla każdej z kategorii -->
          <div class="col-xs-2 mt30 mx10 pt5 p0">
            <div v-if="parseBaner" class="pt5 uppercase sub-category-header p0">
              {{ $t(parseBaner.title1) }}
            </div>
            <div v-if="parseBaner" class="image-box">
              <router-link
                @click.native="heeadBarShow = false"
                class="image-wrapper"
                :to="
                  parseBaner.link1 ? localizedRoute(parseBaner.link1) : '/home'
                "
              >
                <img
                  class="megamenu-image"
                  v-lazy="
                    getThumbnailPath(
                      parseBaner.image1,
                      getConfigSquareImageWidth,
                      getConfigSquareImageHeight,
                    )
                  "
                  alt="category image"
                />
              </router-link>
            </div>
            <div
              v-if="parseBaner"
              class="py10 flex h5 submenu-text start-xs no-underline"
            >
              {{ $t("Learn More") }} <span class="arrow-hover">➜</span>
            </div>
          </div>
          <div class="col-xs-2 mt30 mx10 pt5 p0">
            <div v-if="parseBaner" class="pt5 uppercase sub-category-header p0">
              {{ $t(parseBaner.title2) }}
            </div>
            <div v-if="parseBaner" class="image-box">
              <router-link
                @click.native="heeadBarShow = false"
                class="image-wrapper"
                :to="
                  parseBaner.link2 ? localizedRoute(parseBaner.link2) : '/home'
                "
              >
                <img
                  class="megamenu-image"
                  v-lazy="
                    getThumbnailPath(
                      parseBaner.image2,
                      getConfigSquareImageWidth,
                      getConfigSquareImageHeight,
                    )
                  "
                  alt="category image"
                />
              </router-link>
            </div>
            <div
              v-if="parseBaner"
              class="py10 h5 submenu-text start-xs no-underline"
            >
              {{ $t("Learn More") }} <span class="arrow-hover">➜</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
import { formatCategoryLink } from "@vue-storefront/core/modules/url/helpers";
import groupBy from "lodash-es/groupBy";
import { getThumbnailPath as _thumbnailHelper } from "@vue-storefront/core/helpers";
import config from "config";

export default {
  data() {
    return {
      subHeadBarShow: false,
      heeadBarShow: false, // todo: use only subHeadBarShow
      activeFirstLevelCategory: null,
      activeSecondLevelCategory: null,
    };
  },
  computed: {
    ...mapGetters("category-next", ["getMenuCategories"]),
    ...mapGetters({
      getMenuCategories: "category-next/getMenuCategories",
      getAvailableFilters: "category-next/getAvailableFilters",
    }),
    getConfigSquareImageWidth() {
      return config.products.square.width;
    },
    getConfigSquareImageHeight() {
      return config.products.square.height;
    },
    validBaners() {
      return this.$store.state.cmsBlock.baners;
    },
    isSpecialOfferBar() {
      return this.validBaners.specialOfferBar;
    },
    parseBaner() {
      if (!this.activeFirstLevelCategory) return "";
      const id = this.activeFirstLevelCategory.id;
      if (id === config.server.categoryIdsMap.mainCategoryId) {
        return this.validBaners["megamenu_ubrania"];
      } else if (id === config.server.categoryIdsMap.occasionCategoryId) {
        return this.validBaners["megamenu_okazje"];
      } else if (id === config.server.categoryIdsMap.rootDesignerCategoryId) {
        return this.validBaners["megamenu_projektanci"];
      } else if (id === config.server.categoryIdsMap.subscriptionCategoryId) {
        return this.validBaners["megamenu_abonament"];
      } else if (id === config.server.categoryIdsMap.packageCategoryId) {
        return this.validBaners["megamenu_pakiety"];
      } else if (id === config.server.categoryIdsMap.marketplaceCategoryId) {
        return this.validBaners["megamenu_marketplace"];
      } else {
        return "";
      }
    },
    categoriesMap() {
      return this.getMenuCategories
        ? groupBy(this.getMenuCategories, "parent_id")
        : "";
    },
    categoryIdsMap() {
      return config.server.categoryIdsMap;
    },
    secondLevelCategoriesParentId() {
      if (!this.activeFirstLevelCategory) return null;
      return this.activeFirstLevelCategory.id;
    },
    thirdLevelCategories() {
      if (
        !this.activeSecondLevelCategory ||
        !this.categoriesMap[this.activeSecondLevelCategory.id]
      ) {
        return [];
      }
      return this.categoriesMap[this.activeSecondLevelCategory.id].filter(
        (cat) => cat.include_in_menu !== 0,
      );
    },
  },
  methods: {
    getThumbnailPath(image, widht, height) {
      return _thumbnailHelper(image, widht, height, "banners");
    },
    hover() {
      this.heeadBarShow = true;
    },
    currentSubcategory() {
      return this.getMenuCategories
        ? this.getMenuCategories.find(
            (cat) => cat.id === this.secondLevelCategoriesParentId,
          )
        : "";
    },
    resetMenu() {
      this.activeFirstLevelCategory = null;
      this.activeSecondLevelCategory = null;
      this.heeadBarShow = false;
    },
    hoverSecondLevelCategory(secondLevelCategory) {
      this.activeSecondLevelCategory = secondLevelCategory;
      this.$store.dispatch("category-next/fetchMenuCategories", {
        parent: secondLevelCategory.id,
      });
    },
    hoverFirstLevelCategory(category) {
      this.activeFirstLevelCategory = category;
      this.activeSecondLevelCategory = null;
      this.$store.dispatch("category-next/fetchMenuCategories", {
        parent: category.id,
      });
    },
    categoryLink(category) {
      return formatCategoryLink(category);
    },
    notIncludedInMenu(categories) {
      if (!categories) return;
      return categories.filter(
        (category) => category.include_in_menu !== 0,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~theme/css/variables/colors";
@import "~theme/css/helpers/functions/color";
$black: color(black);

.consulting {
  @media (max-width: 1024px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  font-size: 14px;
}
.language {
  align-items: center;
}
.header-section {
  padding-bottom: 5px;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  margin-left: 0;
}
.menu__item {
  display: flex;
  font-size: 14px;
  letter-spacing: 1px;
  color: #141e39;
  @media (max-width: 991px) {
    padding-left: 10px;
    padding-right: 10px;
  }
}
.item-hover:after {
  display: block;
  content: "";
  border-bottom: solid 1px #141e39;
  transform: scaleX(0);
  transition: transform 250ms ease-in-out;
}
.item-hover {
  display: inline-block;
  margin: 0;
  text-transform: uppercase;
}
.item-hover::after {
  transform-origin: 0% 50%;
}
.item-hover:hover:after {
  transform: scaleX(1);
  transform-origin: 0% 50%;
}
.icon-size {
  font-size: 8px;
}
.special-case {
  padding-bottom: 15px;
}
.consulting_menu {
  background-color: #ffffff;
  top: 80px;
  width: 100%;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  .consulting_item {
    text-align: center;
    padding: 10px;
    .link {
      color: black;
      font-size: 16px;
      margin: -10px;
      &:hover {
        color: $black;
      }
    }
  }
}
.menu__item:hover {
}
.sub-category-header {
  text-align: start;
  font-size: 12px;
  color: #141e39;
  font-weight: 600;
}
.megamenu__submenu {
  &.special-offer {
    top: 158px;
  }
  display: flex;
  box-shadow: -1px 6px 8px #78787852;
  justify-content: center;
  padding-left: 100px;
  padding-top: 2px;
  .submenu-item.first-sub {
    &:last-child {
      border-bottom-left-radius: 15px;
    }
  }
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  background-color: whitesmoke;
  top: 134px;
  display: flex;
  .submenu-item {
    display: flex;
    color: #141e39;
    font-weight: 400;
    align-items: center;
    justify-content: start;
    a {
      color: #141e39;
    }
    &:hover,
    &.active {
      .arrow-hover {
        opacity: 1;
        transform: translateX(-20px);
      }
      .menu-icon,
      a {
        text-decoration: underline;
        transition: all 0.35s;
      }
    }
    .menu-icon {
      position: absolute;
      top: calc(50%);
    }
  }
  .submenu-text {
    text-transform: uppercase;
    color: #141e39;
    font-size: 12px;
    font-weight: 500;
  }
}
.ubrania-text {
  color: #141e39;
  max-width: 228px;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
.image-box {
  overflow: hidden;
}
.brdr-bottom-right {
  border-bottom-right-radius: 15px;
}
.megamenu-image {
  width: 100%;
  max-width: 400px;
  height: auto;
}
.image-wrapper {
  display: grid;
}
.megamenu-image:hover {
  transform: scale(1.1);
  transition: all 0.7s;
}
.arrow-hover {
  right: -60px;
  position: absolute;
  opacity: 0;
  transition: opacity 800ms, transform 0.3s ease;
}
.brdr-bottom-left {
  border-bottom-left-radius: 15px;
}
.promo-box {
  background: white;
  border-radius: 24px;
  margin: 30px;
  width: auto;
  // height: 200px;
  overflow: hidden;
  a {
    display: flex;
  }
  .promo-img {
    height: auto;
    width: 100%;
    object-fit: contain;
    object-position: 0 0;
  }
}
</style>
